import { render, staticRenderFns } from "./cOracleHcrCertificate.vue?vue&type=template&id=79c8eaa4&scoped=true"
import script from "./cOracleHcrCertificate.vue?vue&type=script&setup=true&lang=js"
export * from "./cOracleHcrCertificate.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c8eaa4",
  null
  
)

export default component.exports